import Card from 'react-bootstrap/Card';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Accordion from 'react-bootstrap/Accordion';
import { ICONS } from 'Utils/icons';
import { Fade, Stack } from 'react-bootstrap';
import { IconButton, TextButton } from 'Components/Button';
import { NumberedSteps } from 'Components/Public/NumberedSteps/NumberedSteps';
import { ArrowRight, Close, Favorite, ThumbDown, ThumbDownAltOutlined, ThumbUp, ThumbUpAltOutlined } from '@mui/icons-material';
import reCAPTCHA from 'Images/recaptchaimg.png';
import ahrqlogo from 'Images/ahrqlogo.png';
import psoppclogo from 'Images/psoppclogo.png';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import ErrorIcon from '@mui/icons-material/ErrorOutlined';
import { useState } from 'react';
import { getVarValue } from 'Utils/utilityFunctions';

export const PublicAccordion = ({ accordionItemsContent, defaultActiveKey }) => {
    //console.log(defaultActiveKey);

    
    return (
        <Accordion defaultActiveKey={defaultActiveKey} flush alwaysOpen bsPrefix='public-accordion'>

            {accordionItemsContent != null 
                ?
                    accordionItemsContent.map((item, index)=> {
                        return <PublicAccordionItem
                            header={item.header}
                            eventKey={index.toString()}
                        >
                            {getVarValue(item.content)}
                        </PublicAccordionItem>
                    })
                :   null
            }
        </Accordion>

    );
}

const PublicAccordionItem = ({ header, children, eventKey }) => {

    return (
        <Accordion.Item eventKey={eventKey}>
            <Accordion.Header>
                <div className="icon-container arrow">
                    {ICONS.upArrow()}
                </div>
                <Stack direction="horizontal" gap="3">
                    <div className="icon-container">
                        {ICONS.questionMark()}
                    </div>
                    <div className="message">
                        {header}
                    </div>
                    
                </Stack>
            </Accordion.Header>
            <Accordion.Body>
                {children}
            </Accordion.Body>
        </Accordion.Item>
    );
}